module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFBSURBVDiNpVIxTgJRFJx5f6HeG4g3kBssnQoJFEAsCVBYcgPlBLA9JlsSQuIWJFLuDfQGrjfY1iyfZyEQFmWFON28eTP/vZ8H/BP8rVhr9r011h7JCwBQ1Q8Vvr3MnsLcgGqzOwD5AMA98mBC0l/MJo+ZgEaj46YF8wzAO3Hy2BpbWU6DmABQbfVeAVydaN6FFFJbNretbofg/ZlmAHCt8FMErB8ISY4po5GsiwKlXUFZscaWt1whZWvs5R6v7HMAJSeTL/CclRMpdRNoPaYmhmDHxUp2imq7P4LqIGfsPERiZeUf7nYqqBzKchrEIIOzzeRwMZ9E39upHru8Y+7x9hp5fdcpGWve9+TtOoehCYEISn8xn0TbouNYM9JNg6r6xdV6HIZBUmv2PQCwoi5V4mKaxmEY/Pgr3rR7jbyGv/AFA95+YZXibf4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yy10.png
// module id = EQoz
// module chunks = 1